import { useEffect, useState } from "react";
import { getImages } from "../const";

const LiveDealershipActionForm = ({item, updateDealerInfo, handleFitAnalysisModal, backToResultBtn, index, transactions}) => {


    const [formData, setFormData] = useState({
        seller_name_ss: item?.name || "",
        phone: item?.phone || "",
        email: item?.email || "",
    });

    const [isEditing, setIsEditing] = useState({
        seller_name_ss: false,
        phone: false,
        email: false,
    });

    // Handle input change
    const handleChange = (field, value) => {
        setFormData((prev) => ({ ...prev, [field]: value }));
    };

    // Toggle edit mode
    const toggleEdit = (field) => {
        setIsEditing((prev) => ({ ...prev, [field]: !prev[field] }));
    };

    const submitDealerInfo = () => {
        updateDealerInfo(formData);
    }

    useEffect(() => {
        //console.log(formData);
        //updateDealerInfo(formData);
    },[formData])
    const [openMobCIModal, setOpenMobCIModal] = useState(false);
    const handleMobCIModal = () => {
        setOpenMobCIModal(true)
    }
    const closeMobCIModal = () => {
        setOpenMobCIModal(false)
    }
    return (
        <>
            <div className="mob-va-block pb-0">
                <div className="d-lg-none d-flex align-items-center justify-content-between mb-3">
                    <div>
                        <button type="button" className="back-transparent-btn" onClick={() => backToResultBtn(index)}>{`<`} Back to all Results</button>
                    </div>
                    <div>
                        <button type="button" className="edit-transparent-btn text-uppercase" onClick={handleMobCIModal}><img src={getImages('edit-material.svg')}/> Edit Contact</button>
                    </div>
                </div>
                <div className="d-lg-none d-block md-title font-1-2em fw-500 mt-lg-3 mb-2 text-capitalize">{item.name}</div>
                <div className="d-flex align-items-center live-dealership-main-flex flex-wrap mb-lg-3 mb-2">
                    <div className="me-3 mb-2 mb-xl-0">
                        <a className="red-transparent-btn ld-sm-btn w-145 text-uppercase" href={"https://" + item?.source_ss} target="_blank">
                            <img src={getImages("globe-icon.svg")} />
                            Dealer Site
                        </a>
                    </div>
                    <div className="me-3 mb-2 mb-xl-0">
                        <a className="red-transparent-btn ld-sm-btn w-145 text-uppercase" href={'/dealer-analysis?dealership=' + encodeURIComponent(item.name)}>
                            <img src={getImages("chart-icon.svg")} style={{ maxWidth: "20px" }} />
                            EW Analysis
                        </a>
                    </div>
                    <div className="mb-2 mb-xl-0">
                        <button className="red-transparent-btn ld-sm-btn w-145 text-uppercase" onClick={() => {handleFitAnalysisModal(item.marketcheck_name,item.location,transactions)}}>
                            <img src={getImages("bullseye-icon.svg")} style={{ maxWidth: "20px", verticalAlign:"-4px" }} />
                            Fit Analysis
                        </button>
                    </div>
                    <div className={`mob-custom-modal ms-auto ${openMobCIModal ? "open": ""}`}>
                        <div className="d-flex d-lg-none align-items-center justify-content-between mob-custom-header w-100">
                            <div className="mob-header-title">Contact Info</div>
                            <div>
                                {/* <button className="sm-box-close mt-0" type="button" onClick={() => backToResultBtn(index)}> */}
                                <button className="sm-box-close mt-0" type="button" onClick={closeMobCIModal}>
                                    <img src={getImages('white-close.svg')} alt="Close" />
                                </button>
                            </div>
                        </div>
                        <div className="mob-custom-body">
                            <div className="d-lg-flex align-items-center ld-form-flex">
                                {["seller_name_ss", "phone", "email"].map((field) => (
                                    <div className="d-lg-flex align-items-center me-4" key={field}>
                                        <div className="ld-label">{field === "seller_name_ss" ? "Name" : field.charAt(0).toUpperCase() + field.slice(1)}</div>
                                        <div className="position-relative">
                                            <input
                                                type="text"
                                                className="form-control ld-form-control"
                                                value={formData[field]}
                                                onChange={(e) => handleChange(field, e.target.value)}
                                                disabled={!isEditing[field]}
                                                onBlur={(e) => submitDealerInfo()}
                                            />
                                            <button type="button" className="id-edit-icon" onClick={() => toggleEdit(field)}>
                                                <img src={getImages("gray-edit-material.svg")} />
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div className="mt-auto d-lg-none text-center mob-action-pos">
                                <button type="button" className="red-btn text-uppercase w-100">Save</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default LiveDealershipActionForm